import {Route, Routes} from 'react-router-dom';

import {List} from './List';
import {Create} from './Create';
import {ModifyComponent} from './item/Modify';

export default function TemplateInvoice() {

  return (
    <Routes>
      <Route path="create" element={<Create/>}/>
      <Route path="update/:id" element={<ModifyComponent update={true}/>}/>
      <Route path="create/:id" element={<ModifyComponent/>}/>
      <Route path="/" element={<List/>}/>
    </Routes>
  );
}
